import Icon from "@/components/Ui/Icon";
import { Vendor } from "@/contexts/vendor-context";
import { getImgProxyUrl } from "@/utils/image-proxy";

type Props = {
  vendor: Vendor | undefined;
  selectedVendors: string[];
  setSelectedVendors: (vendors: string[]) => void;
};

const VendorCard = ({ vendor, selectedVendors, setSelectedVendors }: Props) => {
  const { name, vendorId, logo } = vendor || {};
  const isSelected = selectedVendors.includes(vendorId || "");
  if (!vendor) return null;
  const setUnsetSelected = () => {
    if (isSelected) {
      setSelectedVendors(selectedVendors.filter((v) => v !== vendorId));
    }
    if (!isSelected) {
      setSelectedVendors([vendorId || "", ...selectedVendors]);
    }
  };
  return (
    <button
      className="row hover:bg-input/30 w-full space-x-3 border-b p-2 transition-colors active:translate-y-px"
      onClick={() => setUnsetSelected()}
    >
      <span className="row relative aspect-square w-7 overflow-hidden rounded-sm bg-white">
        {logo && (
          <img
            className="w-full p-0.5"
            src={getImgProxyUrl(logo, ["rs:fill:64:0"])}
            alt={`${name}'s logotype`}
          />
        )}
        {!logo && <Icon name="sesamy-simple" className="text-xl text-black" />}
      </span>
      <span className="column-left flex flex-1 items-start space-y-1 text-left">
        <span className="text-sm! leading-none tracking-wide first-letter:uppercase">
          {name || vendorId}
        </span>
      </span>
      <span className="bg-input/30 row aspect-square w-7 rounded border">
        {isSelected && <Icon className="text-[14px]" name="checkmark" />}
      </span>
    </button>
  );
};

export default VendorCard;
